<script>

import {mapActions} from "vuex";
import ChooseRecycleDisposalPatternBotton from '@/driver/components/ChooseRecycleDisposalPatternBotton.vue'

export default {
  name: "ModifyRecycleDisposalReportBasic",
  components: {
    ChooseRecycleDisposalPatternBotton,
  },
  props: {
    /**
     * マニフェスト（処分報告情報）
     */
    manifest: {
      type: Object,
      default: () => ({}),
    },
    manifestDisposal: {
      type: Object,
      default: () => {},
    },
    canEdit: {
      type: Boolean,
      default: () => false,
    },
    isActive: {
      type: Boolean,
      default: () => false,
    },
    canToggle: {
      type: Boolean,
      default: () => false,
    },
    showToggleButton: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {

      standardQuantityTypes: [
        { value: 'fixed_quantity', text: '確定数量' },
        { value: 'waste_quantity', text: '廃棄物の数量' },
        { value: 'transport_quantity', text: '運搬業者の数量' },
        { value: 'disposal_quantity', text: '処分数量' },
      ],
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
      patternId: null,
      plantProcessMethods: [],

    }
  },
  computed: {
    recyclePatternDialogCondition () {
      return {
        item_id: this.manifest?.item_id,
        disposer_id: this.manifest?.disposer_id,
        disposer_location_id: this.manifest?.disposer_location_id,
        disposer_location_code: this.manifest?.disposer_location_code,
        final_disposal: true,
      }
    },
    isRecycleSelectDisabled () {
      return !this.canEdit
    },
    /**
     * 処分場処理情報が必須かどうかを判定する
     * 紙マニフェスト以外の時のみ必須
     */
    isDisposalInfoRequired () {
      return this.manifest?.manifest_type !== 'paper_form'
    },
  },
  watch: {
    /**
     * 品目・処分先・処分場所コードの変更を監視し、処分場処理方法の候補を更新する
     */
    recyclePatternDialogCondition: {
      handler () {
        this.refreshPlantProcessMethods()
      },
      immediate: true,
      deep: true,
    },
    /**
     * 処分報告一覧の先頭から処分場処理方法を初期化する
     */
    'manifestDisposal.manifest_recycle_disposal_reports': {
      handler (reports) {
        this.initializePatternId(reports)
      },
      immediate: true,
      deep: true,
    },
  },
  // mounted() {
  //   this.onStandardQuantityChange(this.manifestDisposal.disposal_standard_quantity_type)
  // },
  created() {},
  methods: {

    /**
     * 処分場処理方法の取得
     */
    ...mapActions("DriverMasterSearchRecycleDisposerDisposalMethod", {
      fetchRecycleMethods: "index",
    }),
    isZeroQuantity (value) {
      return Number(value) === 0
    },
    /**
     * 基準重量変更イベント.
     */
    onStandardQuantityChange (selectedType) {
      if (!selectedType) {
        return
      }

      let convertedKey = null

      if (selectedType === 'fixed_quantity') {
        convertedKey = 'conversion_fixed_quantity'
      } else if (selectedType === 'waste_quantity') {
        convertedKey = 'conversion_waste_quantity'
      } else if (selectedType === 'transport_quantity') {
        convertedKey = 'conversion_transport_quantity'
      } else if (selectedType === 'disposal_quantity') {
        convertedKey = 'conversion_disposal_quantity'
      }

      if (!convertedKey) {
        return
      }

      const convertedQuantity = this.manifestDisposal?.[convertedKey] ?? this.manifest?.[convertedKey]

      if (convertedQuantity === undefined || convertedQuantity === null || convertedQuantity === '') {
        return
      }

      this.$set(this.manifestDisposal, 'disposal_quantity', convertedQuantity)
    },
    initializePatternId (reports) {
      const firstReport = reports && reports.length > 0 ? reports[0] : null
      const nextPatternId = firstReport?.recycle_disposer_disposal_method_id || null

      if (!nextPatternId || this.patternId === nextPatternId) {
        return
      }

      this.patternId = nextPatternId
    },
    patternChangeEvent () {
      // 処分場処理方法が選択された時の処理
      // 選択されたパターンの情報を取得して親に通知
      const selectedPattern = this.plantProcessMethods.find(p => p.value === this.patternId);
      if (selectedPattern) {
        this.$set(this.manifest, 'pattern', {
          id: this.patternId,
          type: selectedPattern.type || 'recycle'
        });
      } else {
        this.$set(this.manifest, 'pattern', null);
      }
      this.$emit("pattern-changed", this.patternId);
    },

    /**
     * 品目と処分先に応じて処分場処理方法の候補を取得する
     */
    refreshPlantProcessMethods () {

      const condition = this.recyclePatternDialogCondition

      if (!condition.item_id || !condition.disposer_id || !condition.disposer_location_code) {
        this.plantProcessMethods = []
        return Promise.resolve()
      }

      return this.fetchRecycleMethods({
        item_id: condition.item_id,
        disposer_id: condition.disposer_id,
        disposer_location_code: condition.disposer_location_code,
        final_disposal: true,
      }).then((content) => {
        this.plantProcessMethods = content.recycle_disposer_disposal_methods || []
      }).catch(() => {
        this.plantProcessMethods = []
      })
    },

    /**
     * 処分場処理方法検索モーダルの選択結果を反映する
     * @param payload {{ pattern: { id: number, type: string, pattern_name: string } }}
     */
    choseRecycleDisposalPatternCallback (payload) {
      const pattern = payload?.pattern
      if (!pattern || pattern.type !== 'methods') {
        return
      }

      const selectedId = pattern.id
      if (!this.plantProcessMethods.some(method => method.value === selectedId)) {
        this.plantProcessMethods.push(
          {
            value: selectedId,
            text: pattern.pattern_name,
            pattern_name: pattern.pattern_name,
          }
        )
      }
      this.patternId = selectedId
      this.patternChangeEvent()
    },
  },
}
</script>

<template>
  <div class="reportLayer">
    <div class="d-flex align-center pb-3 section-title-row">
      <h4 class="mb-0">再資源化等情報</h4>
      <v-btn
        v-if="showToggleButton"
        small
        :outlined="!isActive"
        :color="isActive ? 'primary' : 'default'"
        :disabled="!canToggle"
        @click="$emit('activate-section')"
      >
        {{ isActive ? '編集中' : '編集する' }}
      </v-btn>
    </div>

    <!-- 基準重量, 重量 -->
    <v-row dense >
      <v-col cols="3">
        <validation-provider
          v-slot="{ errors }"
          :class="{ requiredMark: isDisposalInfoRequired }"
          :rules="canEdit && isDisposalInfoRequired ? 'required' : ''"
          name="基準重量"
        >
          <v-select
            v-model="manifestDisposal.disposal_standard_quantity_type"
            :disabled="!canEdit"
            :error-messages="errors"
            :items="standardQuantityTypes"
            dense
            hide-details="auto"
            label="基準重量"
            outlined
            clearable
            persistent-placeholder
            @change="onStandardQuantityChange"
          />
        </validation-provider>
      </v-col>

      <v-col cols="2">
        <validation-provider
          v-slot="{ errors }"
          name="重量"
          :custom-messages="customMessages"
          :class="{ requiredMark: canEdit && isDisposalInfoRequired }"
          :rules="canEdit ? (isDisposalInfoRequired ? 'required|double|min_value:0.001|max_value:9999999999.999' : 'double|min_value:0.001|max_value:9999999999.999') : ''"
        >
          <v-text-field
            v-model="manifestDisposal.disposal_quantity"
            :disabled="!canEdit"
            :error-messages="errors"
            dense
            hide-details="auto"
            label="重量"
            outlined
            persistent-placeholder
            type="number"
            reverse
            @keydown.69.prevent
          >
            <template v-slot:prepend-inner>
              <span class="mt-1 mr-1">kg</span>
            </template>
          </v-text-field>
        </validation-provider>
      </v-col>

      <!-- 処分場処理方法 -->
      <v-col cols="4">
        <div class="d-flex align-start" style="gap: 8px;">
          <validation-provider
            v-slot="{ errors }"
            :class="{ requiredMark: isDisposalInfoRequired }"
            :rules="canEdit && isDisposalInfoRequired ? 'required' : ''"
            name="処分場処理方法"
            class="flex-grow-1"
          >
            <v-select
              v-model="patternId"
              :disabled="!canEdit"
              :error-messages="errors"
              :items="plantProcessMethods"
              clearable
              dense
              label="処分場処理方法"
              hide-details="auto"
              outlined
              persistent-placeholder
              @change="patternChangeEvent"
            >
              <!-- 候補一覧: バッジ＋パターン名 -->
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on" v-bind="attrs">
                  <v-list-item-content>
                    <div class="d-flex align-center flex-wrap py-1" style="gap: 8px;">
                      <v-chip color="primary" label text-color="white" x-small>処分場処理方法</v-chip>
                      <span class="font-weight-medium">{{ item.pattern_name || item.text }}</span>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <!-- 選択後（入力欄）はパターン名のみ -->
              <template v-slot:selection="{ item }">
                {{ item.pattern_name || item.text }}
              </template>
            </v-select>
          </validation-provider>
          <div class="select-actions">
            <choose-recycle-disposal-pattern-botton
              :disabled="isRecycleSelectDisabled"
              :fixed-condition="recyclePatternDialogCondition"
              small-button
              button-caption="選択"
              only-method
              :final-disposal=true
              @choseRecycleDisposalPatternCallback="choseRecycleDisposalPatternCallback"
            />
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped lang="scss">
// outlinedフィールドのラベルに背景色を設定して枠線と重ならないようにする
::v-deep .v-text-field--outlined,
::v-deep .v-select--outlined {
  .v-label {
    background-color: white;
    padding: 0 4px;
  }
  // ダークモードやテーマに応じて背景色を調整する場合
  &.v-input--is-disabled .v-label {
    background-color: #fafafa;
  }
}

// 確定数量が0の場合の黄色いインジケーター
.yellow-indicator {
  color: #ffeb3b;
  font-size: 16px;
  line-height: 1;
}

// 計算値と異なる場合のオレンジ色のインジケーター
.orange-indicator {
  color: #FF9800;
  font-size: 16px;
  line-height: 1;
}

.section-title-row {
  gap: 8px;
}

.select-actions {
  margin-left: 8px;
  padding-top: 4px;
}
</style>
